import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DetailsPopUpComponent } from '../../custom-components/details-pop-up/details-pop-up.component';
import { Router } from '@angular/router';
import { MtxTooltipModule } from '@ng-matero/extensions/tooltip';
import { ConfigComponent } from '../../custom-components/config/config.component';
import { ComponentType } from '@angular/cdk/portal';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [MatButtonModule, CommonModule, MtxTooltipModule, MatSlideToggleModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() data!: any;
  @Input() selectedKey!: string;
  @Output() selectionChange = new EventEmitter<string>();
  tableData: any;
  quadrant = 5;

  constructor(
    private dialog: MatDialog,
    private route: Router
  ) {}

  onClick(value: string) {
    this.selectionChange.emit(value); // Notify parent

    if (this.data && this.data?.type == 'popup') {
      this.openPopUp(this.data.componentName || "DetailsPopUpComponent");
    }
    if (this.data && this.data?.type == 'navigate') {
      this.route.navigate([this.data.url]);
    }
  }

  openPopUp(component: ComponentType<any> | string) {
    let compRef: ComponentType<any>;

    if (!component) {
      compRef = DetailsPopUpComponent;
    } else if (typeof component === 'string') {
      // map known string names to component classes
      switch (component) {
        case 'DetailsPopUpComponent':
          compRef = DetailsPopUpComponent;
          break;
        case 'ConfigComponent':
          compRef = ConfigComponent;
          break;
        default:
          console.error('Unknown component name for dialog:', component);
          return;
      }
    } else {
      compRef = component;
    }
     if (compRef === DetailsPopUpComponent) {
      const data: any = localStorage.getItem('filteredData');
      this.dialog.open(DetailsPopUpComponent, {
        width: '1000px',
        data: this.getStatusTable(JSON.parse(data)),
      });
    } else {
      // open resolved component class
      this.dialog.open(compRef, {
        width: '1000px',
        data: this.data,
      });
    }
  }

  getStatusTable(data: any) {
    const tableData: any = {
      exceeds: [],
      meets: [],
      under: [],
    };
    for (const key in data) {
      data[key].map((point: any) => {
        const [x, y] = point.value;
        const actualQuadrant = this.getQuadrant(x, y);
        const expectedQuadrant = key;
        if (actualQuadrant === expectedQuadrant) {
          tableData.meets.push({ name: point.name, revenue: point.value[2] });
        } else {
          switch (expectedQuadrant) {
            case 'q1':
              if (['q2', 'q3', 'q4'].includes(actualQuadrant)) {
                tableData.exceeds.push({
                  name: point.name,
                  revenue: point.value[2],
                });
              }
              break;
            case 'q2':
              if (['q1', 'q3', 'q4'].includes(actualQuadrant)) {
                tableData.under.push({
                  name: point.name,
                  revenue: point.value[2],
                });
              }
              break;
            case 'q3':
              if (['q2', 'q4', 'q1'].includes(actualQuadrant)) {
                tableData.exceeds.push({
                  name: point.name,
                  revenue: point.value[2],
                });
              }
              break;
            case 'q4':
              if (actualQuadrant === 'q2') {
                tableData.exceeds.push({
                  name: point.name,
                  revenue: point.value[2],
                });
              } else if (['q1', 'q3'].includes(actualQuadrant)) {
                tableData.under.push({
                  name: point.name,
                  revenue: point.value[2],
                });
              }
              break;
          }
        }
      });
    }
    this.tableData = tableData;
    return this.tableData;
  }
  private getQuadrant(x: number, y: number): string {
    if (x > this.quadrant && y > this.quadrant) return 'q2';
    if (x <= this.quadrant && y > this.quadrant) return 'q1';
    if (x <= this.quadrant && y <= this.quadrant) return 'q3';
    if (x > this.quadrant && y <= this.quadrant) return 'q4';
    return '';
  }
}
